import React from 'react';
import { connect } from 'react-redux';
import Article from '../components/Article/Article';
import { DragDropContext } from "react-beautiful-dnd";
import TemplateWrapper from '../../../../template/containers/TemplateLayout/TemplateWrapper';
import { templateActions } from '../../../../../../store/actions/cms/template/template.action';
import ArticleMenu from '../components/ArticleMenu/ArticleMenu';
import { MobileLoader } from '../../../../../../components/UI/Spinner/MobileLoader';
import { lazyLoad } from '../helpers/imageLoader.lazy';
import './ArticleFeed.css';
import { authHeader } from '../../../../../../helpers/authHeader';
class ArticleFeed extends React.Component {
    state = {
        articles: [],
        isLoaded: false,
        template: null
    }
    componentDidMount() {
        //Load articles from server
        window.scrollTo(0, 0);
        //Load extra images
        this.downloadArticles();
        const { match } = this.props;
        const eventId = match.params.id;
        this.props.dispatch(templateActions.getDefaultTemplateByEvent(eventId));
        document.addEventListener("scroll", lazyLoad);
        window.addEventListener("orientationchange", lazyLoad);

    }
    componentDidUpdate(prevProps) {
        if (this.props.template.template !== undefined && prevProps.template.template !== this.props.template.template) {
            this.setState({ template: this.props.template.template.content });
        }
    }
    downloadArticles = () => {
        const { match } = this.props;
        const eventId = match.params.id;
        const requestOptions = {
            method: "GET",
            headers: authHeader({ "Content-Type": "application/json" })
        };
        fetch(`./api/article/${eventId}`, requestOptions)
            .then(res => res.json())
            .then(articles => {
                this.setState({
                    articles,
                    isLoaded: true
                }, () => {
                    lazyLoad();
                })
            })
            .catch(err => { this.setState({ isLoaded: true }) });
    }
    render() {
        const { articles, isLoaded, template } = this.state;
        const { user, match } = this.props;
        return (
            <DragDropContext>
                <TemplateWrapper >
                    {user && user.eid.toString() === match.params.id && <ArticleMenu />}
                    {!isLoaded && <MobileLoader />}
                    <div className="article-feed">
                        {isLoaded === true && articles.length > 0 && articles.map((a, i) => {
                            return <Article
                                key={i}
                                isEditable={user && user.eid.toString() === match.params.id}
                                template={template}
                                {...a}
                            />
                        })}
                        {isLoaded && articles.length === 0 && (
                            <h4 className="no-articles center">Det finns inga artiklar att läsa</h4>
                        )}
                    </div>
                </TemplateWrapper>
            </DragDropContext>
        )
    }
}
function mapStateToProps(state) {
    return {
        user: state.authentication.user,
        template: state.template,
        cms: state.cms
    };
}
export default connect(mapStateToProps)(ArticleFeed);

